"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.recentTweets = exports.recentTweetsResultSchema = exports.recentTweetsArgsSchema = void 0;
var zod_1 = require("zod");
var common_1 = require("./common");
// Argument schema
exports.recentTweetsArgsSchema = zod_1.z.object({
    query: zod_1.z
        .string()
        .describe('Search query for tweets. Supports: keywords ("iPhone 15"), hashtags ("#AI"), usernames (from:elonmusk), advanced syntax ("(product OR brand) -is:retweet has:media")'),
    count: zod_1.z
        .number()
        .min(1)
        .max(499)
        .nullish()
        .describe('Number of tweets to fetch (default 100, max 499)'),
    emitMode: common_1.emitModeSchema.describe('The mode to emit the tweets in.'),
    options: zod_1.z
        .object({
        failIfEmpty: zod_1.z
            .boolean()
            .default(true)
            .describe('Fail if the search returns no results. Default to true.'),
    })
        .describe('Search options'),
});
// Result schema (full TweetResult structure)
exports.recentTweetsResultSchema = zod_1.z.array(zod_1.z.object({
    id: zod_1.z.string(),
    text: zod_1.z.string(),
    created_at: zod_1.z.string(),
    author_id: zod_1.z.string(),
    author_name: zod_1.z.string(),
    author_username: zod_1.z.string(),
    author_verified: zod_1.z.boolean(),
    author_followers_count: zod_1.z.number(),
    author_following_count: zod_1.z.number(),
    author_tweet_count: zod_1.z.number(),
    author_listed_count: zod_1.z.number(),
    media: zod_1.z.array(zod_1.z.object({
        media_key: zod_1.z.string(),
        type: zod_1.z.string(),
        url: zod_1.z.string(),
    })),
    public_metrics: zod_1.z.object({
        retweet_count: zod_1.z.number(),
        reply_count: zod_1.z.number(),
        like_count: zod_1.z.number(),
        quote_count: zod_1.z.number(),
    }),
    entities: zod_1.z.object({
        urls: zod_1.z.array(zod_1.z.object({
            url: zod_1.z.string(),
            expanded_url: zod_1.z.string().nullish(),
            display_url: zod_1.z.string(),
        })),
    }),
}));
exports.recentTweets = (0, common_1.createEmitModeToolMetadata)({
    id: 'recentTweets',
    displayName: 'Recent Tweets',
    displayDescription: 'Fetch recent tweets for a given query.',
    category: 'search',
    color: common_1.BRAND_COLORS.TWITTER,
    backgroundColor: (0, common_1.createBgColor)(common_1.BRAND_COLORS.TWITTER),
    icon: 'twitter',
    argsSchema: exports.recentTweetsArgsSchema,
}, exports.recentTweetsResultSchema);
